import React from 'react';

import { ExitingPersistence } from '@atlaskit/motion';
import Portal from '@atlaskit/portal';

import { Wrapper } from './container';
import type { FocusStateProps } from './types';

const FocusState = ({ isOpen, ...props }: FocusStateProps) => (
	<Portal zIndex="unset">
		<ExitingPersistence appear>{isOpen && <Wrapper {...props} />}</ExitingPersistence>
	</Portal>
);

export default FocusState;
